export const createDedupedRefresh = ({ refresh }) => {
    let isRefreshing = false;
    let pendingRequests = [];
    const setIsRefreshing = (value) => {
        isRefreshing = value;
    };
    const addPendingRequest = (pendingRequest) => {
        pendingRequests.push(pendingRequest);
    };
    const resolvePendingRequests = (t) => {
        pendingRequests.map(callback => callback(t));
        pendingRequests = [];
    };
    return (opts) => {
        if (!isRefreshing) {
            setIsRefreshing(true);
            return refresh(opts)
                .then(t => {
                resolvePendingRequests(t);
                setIsRefreshing(false);
                return t;
            })
                .catch(e => {
                resolvePendingRequests();
                setIsRefreshing(false);
                throw e;
            });
        }
        else {
            return new Promise(resolve => {
                addPendingRequest(t => resolve(t));
            });
        }
    };
};
//# sourceMappingURL=createDedupedRefresh.js.map